import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Row, Col, Checkbox, Button, Space } from 'antd';
import { PlusOutlined, FilterOutlined, SortAscendingOutlined, SortDescendingOutlined, FolderOpenOutlined, ReloadOutlined } from '@ant-design/icons';
import './Filter.less';
import { SortOptions ,DemandPageModel, Demand} from '../model';
import { User } from '@/common/model';
import { IconFont } from '@/common';
import AddEdit from './AddEdit';

interface FilterProps {
  model: DemandPageModel;
  currentUser: User;
}

const Filter: React.FC<FilterProps> = observer(({ model, currentUser }) => {

  const [selectedDemand, setSelectedDemand] = useState<Demand | undefined>(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);


  const handleAdd = () => {
    setSelectedDemand(undefined);
    setIsModalVisible(true);
  }; 

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };
 

  const handleFilterChange = (status: number) => {
    if (model.filterOptions.status.includes(status)) {
      model.filterOptions.status = model.filterOptions.status.filter((s) => s !== status);
    } else {
      model.filterOptions.status.push(status);
    }
    model.applyFilters(); // 更新过滤器
  };

  const handleOwnChange = () => {
    model.filterOptions.submitterId = model.filterOptions.submitterId ? null : currentUser.id;
    model.applyFilters(); // 更新过滤器
  };

  const handleSortChange = (field: keyof SortOptions) => { 

      model.sortOptions.order = model.sortOptions.order === 'asc' ? 'desc' : 'asc';

      Object.keys(model.sortOptions).forEach(key => { 
        if( String(key) !== 'order'){
            model.sortOptions[key] = null; 
        }
      });

      if(field === 'bySubmitTime'){
          model.sortOptions.bySubmitTime = model.sortOptions.bySubmitTime ? false : true;
      }
      if(field === 'bySubmitter'){
          model.sortOptions.bySubmitter = model.sortOptions.bySubmitter ? false : true;
      }
      if(field === 'byExecutor'){
          model.sortOptions.byExecutor = model.sortOptions.byExecutor ? false : true;
      }
      if(field === 'byStatus'){
          model.sortOptions.byStatus = model.sortOptions.byStatus ? false : true;
      }

      model.applySort(); // 更新排序
  };

  const sortIcon = (field: keyof SortOptions) => {
    if (model.sortOptions[field] == null) return null;
    return model.sortOptions.order === 'asc' ? <SortAscendingOutlined /> : <SortDescendingOutlined />;
  };

  return (
    <div className="filter-container">
      <Row className="filter-row" gutter={[16, 16]}>
        <Col>
           <IconFont type='icon-shaixuan1' style={{fontSize:20,marginTop:'3px'}}/>
        </Col>
        <Col style={{paddingLeft:22}}>
          <Checkbox onChange={() => handleFilterChange(0)}>只看待立项</Checkbox>
        </Col>
        <Col>
          <Checkbox onChange={() => handleFilterChange(1)}>只看已立项</Checkbox>
        </Col>
        <Col>
          <Checkbox onChange={() => handleFilterChange(2)}>只看已废弃</Checkbox>
        </Col>
        <Col>
          <Checkbox onChange={handleOwnChange}>只看自己</Checkbox>
        </Col>
        <Col flex="auto" className="add-demand-col">
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} className="add-demand-button">
            添加需求
          </Button>
        </Col>
      </Row>
      <Row className="sort-row" gutter={[16, 16]}>
        <Col>
            <IconFont type='icon-icon-' style={{fontSize:20,marginTop:'3px'}}/>
        </Col>
        <Col className="sort-item">
          <Button type="text" onClick={() => handleSortChange('bySubmitTime')}>
            提出时间 {sortIcon('bySubmitTime')}
          </Button>
        </Col>
        <Col className="sort-item">
          <Button type="text" onClick={() => handleSortChange('bySubmitter')}>
            提出人 {sortIcon('bySubmitter')}
          </Button>
        </Col>
        <Col className="sort-item">
          <Button type="text" onClick={() => handleSortChange('byExecutor')}>
            负责人 {sortIcon('byExecutor')}
          </Button>
        </Col>
        <Col className="sort-item">
          <Button type="text" onClick={() => handleSortChange('byStatus')}>
            状态 {sortIcon('byStatus')}
          </Button>
        </Col>
        <Col flex="auto" className="sort-right">
          <Space size={0}>
            <span style={{marginRight: 20}}>共{model.demandList.length}条</span>
            <Button  icon={<FolderOpenOutlined />} type="text" className='btn-refresh'  onClick={model.collapseAll}>折叠</Button>
            <Button icon={<ReloadOutlined />} type="text" className='btn-refresh' onClick={model.refresh}>刷新</Button>
          </Space>
        </Col>
      </Row> 

      <AddEdit
          visible={isModalVisible}
          onClose={handleCloseModal} 
          currentUser={currentUser} 
      />
    </div>
  );
});

export default Filter;